import { render, staticRenderFns } from "./RingValTextItem.vue?vue&type=template&id=f4ebe118&scoped=true"
import script from "./RingValTextItem.vue?vue&type=script&lang=js"
export * from "./RingValTextItem.vue?vue&type=script&lang=js"
import style0 from "./RingValTextItem.vue?vue&type=style&index=0&id=f4ebe118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ebe118",
  null
  
)

export default component.exports